import { computed, useI18n, useRuntimeConfig } from '#imports';
import { canViewAuthSidebarExternalLink } from 'r3ui-lib';
import { useAuthStore } from '~/stores/auth';
import { getUniqueKey, getChildrensIsActive } from '~/utils/helpers';
import useRegistrationLinks from '~/composables/sidebar/useRegistrationLinks';
import useGeneralLinks from '~/composables/sidebar/useGeneralLinks';
import useEpizootologyLinks from '~/composables/sidebar/useEpizootologyLinks';

/**
 * Сборка sidebarLinks для MainComponent.
 * Accordion/visibility — внутри r3ui Sidebar → useSidebar (Symbol keys).
 */
export function useSidebarShell() {
  const authStore = useAuthStore();
  const config = useRuntimeConfig();
  const { t } = useI18n();

  const { links: registrationLinks } = useRegistrationLinks();
  const { links: generalLinks } = useGeneralLinks();
  const { links: epizootologyLinks } = useEpizootologyLinks();
  const handbookKey = getUniqueKey();
  const loginKey = getUniqueKey();
  const registryKey = getUniqueKey();

  const mainLinks = computed(() => {
    const links = [
      {
        level: 0,
        uniqueKey: handbookKey,
        isVisible: authStore.hasUserPermission('sidebar-view-handbook'),
        icon: `<i class="bi bi-book-fill"></i>`,
        label: t('routes.handbook'),
        isActive: false,
        childrens: [
          ...generalLinks.value,
          ...registrationLinks.value,
          ...epizootologyLinks.value,
        ],
      },
    ];

    if (links[0]) {
      links[0].isActive = getChildrensIsActive(links);
    }
    return links;
  });

  const additionalLinks = computed(() => {
    return [
      {
        level: 0,
        uniqueKey: loginKey,
        isVisible: canViewAuthSidebarExternalLink(authStore.hasUserPermission),
        href: config?.public?.authLink,
        icon: `<i class="bi bi-person-square"></i>`,
        label: t('routes.login'),
        isActive: false,
        isExternal: true,
        openInNewWindow: false,
      },
      {
        level: 0,
        uniqueKey: registryKey,
        isVisible: true,
        href: config?.public?.registryLink,
        icon: `<i class="bi bi-file-earmark-text-fill"></i>`,
        label: t('routes.registry'),
        isActive: false,
        isExternal: true,
        openInNewWindow: false,
      },
      ...mainLinks.value,
    ];
  });

  const sidebarLinks = computed(() => {
    return [...additionalLinks.value];
  });

  return {
    sidebarLinks,
  };
}
